import { render, staticRenderFns } from "./svg-icon-tmpl.vue?vue&type=template&id=15af899e&scoped=true&"
var script = {}
import style0 from "./svg-icon-tmpl.vue?vue&type=style&index=0&id=15af899e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15af899e",
  null
  
)

export default component.exports